import styled from 'styled-components';

const Row = styled.div`
  display: flex;
  color: rgb(54, 61, 74);
`;

export default Row;
